<template>
  <div
    class="tw-fixed modal-wrapper tw-flex tw-items-center tw-justify-center tw-w-screen tw-h-screen tw-left-0 tw-top-0"
    @mousedown.self="close(false)">
    <transition name="modal-slide">
      <div v-show="animateBox"
           :class="[type, {'tw-text-center': type === 'dialog'}]"
           class="modal tw-flex tw-flex-col tw-bg-white tw-rounded-lg tw-relative">
        <i
          v-if="closeable"
          class="fal fa-times tw-cursor-pointer tw-absolute tw-top-0 tw-text-base tw-right-0 tw-pr-3 tw-pt-3 tw-text-gray-300 tw-text-sm tw-z-20 hover:tw-opacity-75"
          @click="close(false)"></i>
        <slot name="modal-header"></slot>
        <smooth-reflow :options="{property: 'height', transition: 'height .3s'}">
          <div v-bar>
            <div>
              <div
                :class="[{'tw-items-center tw-justify-center': type === 'dialog'}, {'tw-items-start tw-justify-start': type === 'input'}]"
                class="tw-flex tw-flex-col tw-flex-1 tw-px-5 tw-pt-8 tw-pb-2 tw-h-full tw-modal-content tw-text-gray-700 tw-leading-relaxed">
                <slot name="modal-content"></slot>
              </div>
            </div>
          </div>
          <div
            :class="[{'tw-items-center tw-justify-center': type === 'dialog'}, {'tw-items-start tw-justify-start': type === 'input'}]"
            class="tw-flex tw-flex-col tw-flex-1 tw-px-5 tw-pb-6 tw-h-full tw-modal-content tw-text-gray-700 tw-leading-relaxed">
            <div v-if="!!this.$slots['modal-bottom']"
                 class="modal-bottom tw-flex tw-justify-between tw-mt-6 tw-items-center tw-w-full">
              <slot name="modal-bottom"></slot>
            </div>
          </div>
        </smooth-reflow>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
  props: {
    activeTab: {
      default: false,
    },
    type: {
      default: 'dialog',
    },
    closeable: {
      default: true,
    },
  },

  name: 'ModalWrapper',

  data() {
    return {
      animateBox: false,
      tab_has_changed: false,
    };
  },

  mounted() {
    this.animateBox = true;
  },

  methods: {
    ...mapMutations('modal',
      ['togglePopup']),

    close(force_close = false) {
      if (this.closeable || force_close) {
        this.$emit('close');
        this.togglePopup(false);
      }
    },
  },

  created() {
    const keyHandler = (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    };

    document.addEventListener('keydown', keyHandler);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', keyHandler);
    });
  },
};
</script>

<style lang="scss">
.modal-wrapper {
  //background: rgba(144, 136, 167, 0.5);
  background: rgba(0, 0, 0, 0.55);
  z-index: 9997;

  .modal {
    width: 95vw;
    min-height: 100px;
    box-shadow: 0 1px 3px #00000029;

    .modal-headers {
      height: 75px;
      border-radius: 5px 5px 0 0;

      .modal-header {
        font-size: 0.8rem;

        .header-active {
          border-radius: 10px;
          height: 3px;
        }
      }
    }

    .vfc-popover-container {
      @apply tw-relative;
    }

    .vfc-main-container.vfc-modal {
      @apply tw-ml-0;
      width: 100% !important;
      box-shadow: 0 2px 4px #f9f9f9;
      border: 1px solid #f7f7f7;
    }

    .time-picker {
      .card-time-picker {
        &.top {
          width: 100%;
        }
      }
    }

    .vb-content {
      max-height: 60vh;

      .form-row {
        @apply tw-ml-0;

        .checkbox {
          .checked {
            left: 0;
            top: 3px;
            width: 15px;
            height: 15px;
          }
        }

        .multiple-choice-answer {
          .checkbox {
            .checked {
              top: 0;
            }
          }
        }
      }

      .froala-wrapper {
        .emoji-wrapper {
          width: 465px;
        }
      }

      &:after {
        @apply tw-absolute tw-z-10 tw-bottom-0 tw-left-0 tw-w-full;
        content: "";
        height: 9px;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(#ffffff));
        background: linear-gradient(to bottom, transparent 0%, #ffffff 100%);
      }
    }

    .modal-bottom {
      .btn {
        @apply tw-py-2 tw-px-6;

        &.secondary-btn {
          @apply tw-text-gray-500;
        }
      }
    }

    &.notification-reminder {
      width: 275px;
    }


    @screen md {
      width: 300px;

      &.medium {
        width: 400px;
      }

      &.large {
        width: 500px;
      }

      &.xlarge {
        width: 560px;
      }
    }
  }
}

.modal-slide-enter-active, .modal-slide-leave-active {
  transition: transform 0.35s, opacity 0.35s;
}

.modal-slide-enter, .modal-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.modal-slide-enter-to, .modal-slide-leave {
  opacity: 1;
  transform: translateY(0);
}

.modal-overlay-fade-enter-active, .modal-overlay-fade-leave-active {
  transition: opacity 0.05s;
}

.modal-overlay-fade-enter, .modal-overlay-fade-leave-to {
  opacity: 0;
}

.modal-overlay-fade-enter-to, .modal-overlay-fade-leave {
  opacity: 1;
}
</style>
